export const userRoleOptions = [
  { label: "Developer", value: "developer" },
  { label: "Urban planner", value: "urban_planner" },
  { label: "City staff", value: "city_staff" },
  { label: "Architect", value: "architect" },
  { label: "Engineer", value: "engineer" },
  { label: "Asset manager", value: "asset_manager" },
  { label: "Home owner", value: "home_owner" },
];

export const projectTypeOptions = [
  {
    value: "residential",
    title: "Residential",
    description: "- Driveway\n- Walkways\n- Patios\n- Pools",
    icon: "🏠"
  },
  {
    value: "commercial",
    title: "Commercial",
    description: "- Parking lot\n- Neighbourhood\n- Plaza\n- Public spaces",
    icon: "🏢"
  },
  {
    value: "municipal",
    title: "Municipal",
    description: "- Road shoulders\n- Parking lot\n- Bike path\n- Boulevards\n- Public spaces\n- Medians\n- Tree pits\n- Dog parks",
    icon: "🏛️"
  },
];

export const locationTypeOptions = [
  { label: "Downtown", value: "downtown" },
  { label: "Suburban", value: "suburban" },
  { label: "Rural property", value: "rural" },
];

export const landUseOptions = [
  { label: "Residential", value: "Residential" },
  { label: "Neighbourhood", value: "Neighbourhood" },
  { label: "Commercial", value: "Commercial" },
  { label: "Industrial", value: "Industrial" },
  { label: "Municipal", value: "Municipal" },
  { label: "Rural (no stormwater infra)", value: "Rural" },
];

export const soilTypeOptions = [
  { label: "Type A: High Infiltration (Sandy, well-drained)", value: "Type A" },
  { label: "Type B: Moderate Infiltration (Fine to coarse soils)", value: "Type B" },
  { label: "Type C: Slow Infiltration (Fine soils, impeded drainage)", value: "Type C" },
  { label: "Type D: Very Slow Infiltration (Clay soils, high runoff)", value: "Type D" },
  { label: "Unknown", value: "Unknown" },
];

export const stormFrequencyOptions = [
  { label: "2-year", value: 2 },
  { label: "5-year", value: 5 },
  { label: "10-year", value: 10 },
  { label: "25-year", value: 25 },
  { label: "50-year", value: 50 },
  { label: "100-year", value: 100 },
];

export const durationOptions = [
  { label: "5 minutes", value: 5 },
  { label: "10 minutes", value: 10 },
  { label: "15 minutes", value: 15 },
  { label: "30 minutes", value: 30 },
  { label: "60 minutes", value: 60 },
  { label: "2 hours", value: 120 },
  { label: "6 hours", value: 360 },
  { label: "12 hours", value: 720 },
  { label: "24 hours", value: 1440 },
];

// Rooftop options (consistent across all project types)
export const rooftopOptions = [
  { label: "Rooftop", value: "Rooftop", coefficient: 0.85 },
];

// Lawn/Soil options (consistent across all project types)
export const lawnSoilOptions = [
  { label: "Lawn - Sandy soil, flat", value: "Lawn - Sandy soil, flat", coefficient: 0.075 },
  { label: "Lawn - Sandy soil, sloped", value: "Lawn - Sandy soil, sloped", coefficient: 0.125 },
  { label: "Lawn - Heavy soil, flat", value: "Lawn - Heavy soil, flat", coefficient: 0.15 },
  { label: "Lawn - Heavy soil, sloped", value: "Lawn - Heavy soil, sloped", coefficient: 0.20 },
];

// Pavement options by project type
export const pavementOptionsByProjectType = {
  municipal: [
    { label: "Road", value: "Road", coefficient: 0.825 },
    { label: "Parking lot", value: "Parking lot", coefficient: 0.825 },
    { label: "Sidewalk", value: "Sidewalk", coefficient: 0.825 },
    { label: "Boulevard", value: "Boulevard", coefficient: 0.775 },
    { label: "Bike path", value: "Bike path", coefficient: 0.775 },
    { label: "Median", value: "Median", coefficient: 0.775 },
  ],
  commercial: [
    { label: "Parking lot", value: "Parking lot", coefficient: 0.825 },
    { label: "Plaza", value: "Plaza", coefficient: 0.775 },
    { label: "Public spaces", value: "Public spaces", coefficient: 0.775 },
  ],
  residential: [
    { label: "Driveway", value: "Driveway", coefficient: 0.825 },
    { label: "Walkways", value: "Walkways", coefficient: 0.775 },
    { label: "Patios", value: "Patios", coefficient: 0.775 },
  ],
};

// Function to get surface type options based on project type
export const getSurfaceTypeOptions = (projectType) => {
  const pavementOptions = pavementOptionsByProjectType[projectType] || [];

  const result = [
    ...rooftopOptions,
    ...pavementOptions,
    ...lawnSoilOptions,
  ];

  return result;
};

// Legacy export for backward compatibility during transition
export const surfaceTypeOptions = getSurfaceTypeOptions("commercial");

export const sampleAutofillData = {
  // Step 0: User Information
  user_role: "engineer",
  project_type: "commercial",
  location_type: "suburban",
  // Step 1: Basic project information
  project_name: "Samuel engineering site",
  project_location: "1352 Tonolli Road, Mississauga, Ontario L4Y 4C2, Canada",
  site_area: 105000,
  land_use_type: "Industrial",
  soil_type: "Type B",
  pre_development_surfaces: [
    {
      type: "Parking lot",
      percentage: 70,
      coefficient: 0.95
    },
    {
      type: "Rooftop",
      percentage: 30,
      coefficient: 0.95
    }
  ],
  post_development_surfaces: [
    {
      type: "Parking lot",
      percentage: 55,
      coefficient: 0.95
    },
    {
      type: "Rooftop",
      percentage: 45,
      coefficient: 0.95
    }
  ],
  stormwater_target_m3: 250.5,
  storm_frequencies: [
    {
      frequency: 25,
      duration: 60,
      rainfall_intensity: 38.6,
      rainfall_intensity_15min: 101.7,
      rainfall_depth: 38.6
    },
    {
      frequency: 50,
      duration: 1440,
      rainfall_intensity: 4.6,
      rainfall_intensity_15min: 112.8,
      rainfall_depth: 111.4
    }
  ],
  street_address: "1352 Tonolli Road",
  city: "Mississauga",
  state: "Ontario",
  zip_code: "L4Y 4C2",
  latitude: 43.603237,
  longitude: -79.578827,
  property_boundary: {
    type: "FeatureCollection",
    features: [
      {
        id: "kMkhS3RycenHegL0xiwZNRo32qaPtXwH",
        type: "Feature",
        properties: {
          stroke: "#0000FF",
          "stroke-width": 2,
          "stroke-opacity": 1,
          fill: "#0000FF",
          "fill-opacity": 0.3,
          area: 105321.56861795556,
        },
        geometry: {
          coordinates: [
            [
              [-79.5809340740229, 43.60203626613091],
              [-79.57797317248452, 43.604736983396066],
              [-79.57526850280979, 43.60302585599575],
              [-79.57851410641908, 43.60048999937911],
              [-79.5809340740229, 43.60203626613091],
            ],
          ],
          type: "Polygon",
        },
      },
    ],
  },
  property_area_m2: 105000,
};
